import './SuperadminToolbox.scss';

import { mdiChevronLeft, mdiClose } from '@mdi/js';
import { Button, Icon } from 'components';
import {
  deleteDelegateTokens,
  getDelegateAccessToken,
  getDelegateRefreshToken,
  getOriginCompanyId,
  saveAccessToken,
  saveRefreshToken
} from 'helpers/tokenManager';
import React, { useState } from 'react';

const SuperadminToolbox = () => {
  const [isClosed, setIsClosed] = useState(false);
  const isSuperadmin = getDelegateAccessToken() !== ''; // TODO: maybe later we want this also in superadmin section

  const backToAdmin = () => {
    const delegateAccessToken = getDelegateAccessToken();
    const delegateRefreshToken = getDelegateRefreshToken();
    const originCompanyId = getOriginCompanyId();
    saveAccessToken(delegateAccessToken);
    saveRefreshToken(delegateRefreshToken);
    deleteDelegateTokens();
    originCompanyId
      ? window.location.replace(`/admin/companies/${originCompanyId}`)
      : window.location.replace('/');
  };

  if (!isSuperadmin) return null;

  return (
    <div className={`SuperadminToolbox ${isClosed ? 'isClosed' : ''}`}>
      <div className="SuperadminToolbox_close-button" onClick={() => setIsClosed(!isClosed)}>
        <Icon path={isClosed ? mdiChevronLeft : mdiClose} />
      </div>
      {!isClosed && (
        <>
          <div className="SuperadminToolbox_title">Admin menu</div>
          <div className="SuperadminToolbox_content">
            <Button onClick={backToAdmin}>Back to admin</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default SuperadminToolbox;
